import { CheckboxButtonGroupValue } from "./Button";
import { ComboBoxOption } from "./Input";

export const cardElementNames = ["Fire", "Ice", "Wind", "Earth", "Lightning", "Water", "Light", "Dark"] as const;
export type CardElementName = "Fire" | "Ice" | "Wind" | "Earth" | "Lightning" | "Water" | "Light" | "Dark";
export type CardElement = {
    id: number,
    name: CardElementName
}

export const elementNumberMap: Record<string, number> = {
    "Fire": 0,
    "Ice": 1,
    "Wind": 2,
    "Earth": 3,
    "Lightning": 4,
    "Water": 5,
    "Light": 6,
    "Dark": 7
};

export function getDefaultElementQuantityMap(): Record<CardElementName, number> {
    return {
        Dark: 0,
        Earth: 0,
        Fire: 0,
        Ice: 0,
        Light: 0,
        Lightning: 0,
        Water: 0,
        Wind: 0
    };
}

export function sortElements(elements: CardElementName[]) {
    elements.sort((a, b) => {
        return elementNumberMap[a] - elementNumberMap[b];
    });
}

export function getElementsString(elements: CardElementName[]) {
    sortElements(elements);
    return elements.join('/');
}

export function getDefaultElementSelectorState(): CheckboxButtonGroupValue<CardElementName>[] {
    return [
        {
            label: "Fire",
            data: "Fire",
            isChecked: false
        },
        {
            label: "Ice",
            data: "Ice",
            isChecked: false
        },
        {
            label: "Wind",
            data: "Wind",
            isChecked: false
        },
        {
            label: "Earth",
            data: "Earth",
            isChecked: false
        },
        {
            label: "Lightning",
            data: "Lightning",
            isChecked: false
        },
        {
            label: "Water",
            data: "Water",
            isChecked: false
        },
        {
            label: "Light",
            data: "Light",
            isChecked: false
        },
        {
            label: "Dark",
            data: "Dark",
            isChecked: false
        }
    ]
}